import { StateService } from "@uirouter/angularjs";
import { IOnInit } from "angular";
import { IFieldArray } from "AngularFormly";
import { Machine } from "../../../../machines/shared/models/machine";
import { MachineConfiguration } from "../../../../machines/shared/models/machineConfiguration";
import { $confirm } from "../../../../../@custom_types/confirm";
import {
  ServerUtility,
  vsName as ServerUtilityName,
} from "../../../../records/server/serverUtility";

export class DepreciationDetailsViewController implements IOnInit {
  static $inject = ["environment", "$confirm", ServerUtilityName, "$state"];

  depreciation!: any;
  machine!: Machine<MachineConfiguration>;
  currentConfiguration!: MachineConfiguration;

  constructor(
    private readonly environment: { Date: Date },
    private readonly $confirm: $confirm,
    private readonly serverUtility: ServerUtility,
    private readonly $state: StateService
  ) {}

  $onInit(): void {
    this.currentConfiguration = this.machine.Configs?.find(
      (c) => c.CurrentConfiguration
    )!;
  }
  isCurrentYear(detail: { StartDate?: Date; EndDate?: Date }): boolean {
    const startDate = detail.StartDate ?? this.depreciation.UsefulLifeStartDate;
    const endDate = detail.EndDate ?? this.depreciation.UsefulLifeEndDate;
    return (
      startDate <= this.environment.Date && endDate > this.environment.Date
    );
  }
  getDepreciationMethod(method: string) {
    switch (method) {
      case "StraightLine":
        return "Straight Line";
      case "DoubleDecliningBalance":
        return "Double Declining Balance";
      case "SumOfTheYearsDigits":
        return "Sum Of The Years Digits";
      default:
        return "";
    }
  }

  delete() {
    return this.$confirm({
      text: "Are you sure you want to delete this depreciation record?",
    })
      .then(() => {
        this.serverUtility.delete({
          url: "/api/machines/depreciation",
          id: this.depreciation.Id,
        });
      })
      .then(() => this.$state.go("^.configurations"));
  }
}
